import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IconWorld } from "@tabler/icons-react";
import { cn } from "@/shared/lib/utils";
import styles from "./LanguageSwitch.module.scss";
export const LanguageSwitch = ({ language, onSelect, className, }) => {
    return (_jsxs("span", { className: cn(styles.langSwitch, className), children: [_jsx(IconWorld, { size: 18, stroke: 1.6, className: styles.langGlobe, "aria-hidden": "true" }), _jsx("span", { className: styles.langPills, children: ["ru", "en"].map((lng) => (_jsx("button", { type: "button", className: cn(styles.langPill, language === lng && styles.langPillActive), onClick: () => onSelect(lng), children: lng.toUpperCase() }, lng))) })] }));
};
